import { render } from "./User.vue?vue&type=template&id=37ae16e7&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=37ae16e7&scoped=true&lang=css"

import exportComponent from "/Users/thanaphon/Documents/LTC/ltc-poc-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ae16e7"]])

export default __exports__